/*
 * Copyright 2024 Palantir Technologies, Inc. All rights reserved.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

import { EnhancedBase } from "./EnhancedBase.js";
export class EnhancedAction extends EnhancedBase {
  #unsanitizedApiName;
  constructor(common, raw) {
    const unsanitizedApiName = raw.apiName;
    raw = {
      ...raw,
      apiName: camelize(raw.apiName)
    };
    super(common, raw, raw.apiName, "./ontology/actions");
    this.raw = raw;
    this.#unsanitizedApiName = unsanitizedApiName;
  }
  get description() {
    return this.raw.description;
  }
  get unsanitizedApiName() {
    return this.#unsanitizedApiName;
  }
  get parameters() {
    return this.raw.parameters;
  }
  get operations() {
    return this.raw.operations;
  }
  get paramsIdentifier() {
    return `${this.shortApiName}.Params`;
  }
  get definitionIdentifier() {
    return `${this.shortApiName}.Definition`;
  }
  get definitionParamsIdentifier() {
    return `${this.shortApiName}.ParamsDefinition`;
  }
}
function camelize(name) {
  return name.replace(/-./g, segment => segment[1].toUpperCase());
}